import React from "react";

function VehicleQuotePage() {
  const params = new URLSearchParams(window.location.search);
  const vehicleNumber = (
    params.get("registrationNumber") ||
    params.get("vehicle") ||
    "MH12AB1234"
  ).toUpperCase();

  const [formData, setFormData] = React.useState({
    registrationNumber: vehicleNumber,
    rto: "Pune RTO",
    makeModel: params.get("makeModel") || "Maruti Baleno",
    fuel: params.get("fuel") || "Petrol",
    variant: "Zeta Manual",
    registrationDate: "2022-08-14",
    manufacturingDate: "2022-06",
    policyType: params.get("policyType") || "Comprehensive",
    policyExpiryDate: params.get("policyExpiryDate") || "2026-08-24",
    previousPolicyType: "Comprehensive",
    previousInsurer: "HDFC ERGO",
    ncb: params.get("ncb") || "0%",
    hadClaim: "No",
    ownerType: "Individual",
  });

  const updateField = (field, value) => {
    setFormData((current) => ({
      ...current,
      [field]: value,
    }));
  };

  const handleViewQuotes = () => {
    const query = new URLSearchParams({
      registrationNumber: formData.registrationNumber,
      makeModel: formData.makeModel,
      fuel: formData.fuel,
      policyType: formData.policyType,
      policyExpiryDate: formData.policyExpiryDate,
      ncb: formData.ncb,
    });

    window.location.href = `${process.env.PUBLIC_URL || ""}/quotes?${query.toString()}`;
  };

  const vehicleFields = [
    {
      key: "registrationNumber",
      label: "Registration Number",
      type: "text",
      placeholder: "Enter registration number",
    },
    {
      key: "rto",
      label: "RTO",
      type: "select",
      options: ["Pune RTO", "Mumbai Central", "Thane", "Nashik", "Nagpur"],
    },
    {
      key: "makeModel",
      label: "Make Model",
      type: "select",
      options: ["Maruti Baleno", "Hyundai i20", "Tata Nexon", "Kia Sonet", "Honda City"],
    },
    {
      key: "fuel",
      label: "Fuel",
      type: "select",
      options: ["Petrol", "Diesel", "CNG", "Electric"],
    },
    {
      key: "variant",
      label: "Variant",
      type: "select",
      options: ["Zeta Manual", "Alpha Automatic", "Sportz", "XZ Plus", "VX CVT"],
    },
    {
      key: "registrationDate",
      label: "Registration Date",
      type: "date",
    },
    {
      key: "manufacturingDate",
      label: "Manufacturing Date",
      type: "month",
    },
  ];

  const choiceButtonClass = (isActive) =>
    `rounded-full px-4 py-2 text-sm font-semibold transition ${
      isActive
        ? "bg-gradient-to-r from-peach to-coral text-white shadow-[0_10px_20px_rgba(225,95,56,0.2)]"
        : "border border-white/70 bg-[rgba(255,255,255,0.62)] text-slate-600 hover:border-peach/20 hover:text-coral"
    }`;

  const renderVehicleInput = (field) => {
    const sharedClassName =
      "mt-3 w-full rounded-2xl border border-peach/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.72)_0%,rgba(255,243,236,0.95)_100%)] px-4 py-3 font-semibold text-ink outline-none transition focus:border-coral focus:ring-4 focus:ring-peach/12";

    if (field.type === "select") {
      return (
        <select
          value={formData[field.key]}
          onChange={(event) => updateField(field.key, event.target.value)}
          className={sharedClassName}
        >
          {field.options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      );
    }

    return (
      <input
        type={field.type}
        value={formData[field.key]}
        placeholder={field.placeholder}
        onChange={(event) => updateField(field.key, event.target.value)}
        className={sharedClassName}
      />
    );
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top_left,rgba(255,123,84,0.18),transparent_24%),radial-gradient(circle_at_85%_18%,rgba(240,178,71,0.16),transparent_18%),radial-gradient(circle_at_bottom_left,rgba(99,199,171,0.16),transparent_24%),linear-gradient(180deg,#fff8f0_0%,#f6fbff_52%,#eefaf7_100%)] px-4 py-6 text-ink md:px-8">
      <div className="pointer-events-none absolute inset-0 opacity-70">
        <div className="absolute -left-16 top-20 h-64 w-64 rounded-full bg-peach/20 blur-3xl"></div>
        <div className="absolute right-10 top-24 h-48 w-48 rounded-full bg-amber/25 blur-3xl"></div>
        <div className="absolute bottom-10 left-1/3 h-56 w-56 rounded-full bg-mint/20 blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[34px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,250,245,0.92)_0%,rgba(247,251,255,0.92)_100%)] shadow-[0_28px_70px_rgba(20,48,74,0.12)] backdrop-blur-sm">
        <div className="grid gap-6 lg:grid-cols-[380px_1fr] lg:items-start">
          <aside className="relative overflow-hidden border-b border-white/70 bg-[linear-gradient(180deg,rgba(255,236,228,0.92)_0%,rgba(255,245,236,0.96)_46%,rgba(232,246,243,0.94)_100%)] px-7 py-8 text-ink">
            <div className="absolute -right-10 top-10 h-24 w-24 rounded-full bg-sky/20 blur-2xl"></div>
            <div className="absolute bottom-12 left-4 h-24 w-24 rounded-full bg-peach/20 blur-2xl"></div>

            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="inline-flex rounded-full border border-peach/15 bg-peach/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] text-coral">
                  Editable Details
                </div>
                <h1 className="mt-4 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
                  Vehicle Details
                </h1>
                <div className="mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-peach to-coral"></div>
              </div>
              <div className="flex flex-wrap items-center justify-end gap-2">
                <a
                  href="/agent-dashboard"
                  className="rounded-full border border-white/70 bg-[rgba(255,255,255,0.72)] px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 shadow-[0_10px_22px_rgba(43,74,107,0.06)] transition hover:-translate-y-0.5 hover:text-coral"
                >
                  Dashboard
                </a>
                <a
                  href="/buy-now"
                  className="rounded-full border border-white/70 bg-[rgba(255,255,255,0.72)] px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 shadow-[0_10px_22px_rgba(43,74,107,0.06)] transition hover:-translate-y-0.5 hover:text-coral"
                >
                  Back
                </a>
              </div>
            </div>

            <p className="mt-5 text-sm leading-6 text-slate-500">
              Review the detected details and update anything before viewing quotes.
            </p>

            <div className="mt-8 grid gap-4">
              {vehicleFields.map((field) => (
                <div
                  key={field.key}
                  className="rounded-[22px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.58)_0%,rgba(255,247,241,0.74)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]"
                >
                  <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
                    {field.label}
                  </label>
                  {renderVehicleInput(field)}
                </div>
              ))}
            </div>
          </aside>

          <section className="relative px-6 py-8 md:px-8">
            <div className="absolute right-10 top-10 h-24 w-24 rounded-full bg-sky/15 blur-2xl"></div>
            <div className="absolute bottom-14 right-16 h-28 w-28 rounded-full bg-peach/10 blur-3xl"></div>

            <div>
              <div className="inline-flex rounded-full border border-peach/15 bg-peach/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] text-coral">
                Plan setup
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
                Policy preferences
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500">
                Every field on this page can be updated before continuing to quotes.
              </p>
            </div>

            <div className="relative mt-8 grid gap-8">
              <section className="rounded-[28px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,242,234,0.78)_0%,rgba(248,251,255,0.88)_100%)] p-5 shadow-[0_16px_34px_rgba(43,74,107,0.08)]">
                <h3 className="text-2xl font-bold text-slate-700">
                  Which policy type are you interested in?
                </h3>
                <div className="mt-4 flex flex-wrap gap-3">
                  {["Third Party Only", "Comprehensive"].map((option) => (
                    <button
                      key={option}
                      type="button"
                      onClick={() => updateField("policyType", option)}
                      className={choiceButtonClass(formData.policyType === option)}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </section>

              <section>
                <div className="flex items-center gap-3">
                  <h3 className="text-2xl font-bold text-slate-700">Previous Policy Details</h3>
                  <div className="h-1 w-12 rounded-full bg-gradient-to-r from-peach to-coral"></div>
                </div>

                <div className="mt-5 grid gap-5 lg:grid-cols-2">
                  <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                    <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                      Existing Policy Expiry Date
                    </label>
                    <input
                      type="date"
                      value={formData.policyExpiryDate}
                      onChange={(event) => updateField("policyExpiryDate", event.target.value)}
                      className="mt-3 w-full rounded-2xl border border-peach/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.72)_0%,rgba(255,243,236,0.95)_100%)] px-4 py-3 font-semibold text-ink outline-none transition focus:border-coral focus:ring-4 focus:ring-peach/12"
                    />
                  </div>

                  <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                    <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                      Previous Policy Type
                    </label>
                    <div className="mt-3 flex flex-wrap gap-3">
                      {["Third Party", "Comprehensive"].map((option) => (
                        <button
                          key={option}
                          type="button"
                          onClick={() => updateField("previousPolicyType", option)}
                          className={choiceButtonClass(formData.previousPolicyType === option)}
                        >
                          {option}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                    <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                      Previous Insurer
                    </label>
                    <select
                      value={formData.previousInsurer}
                      onChange={(event) => updateField("previousInsurer", event.target.value)}
                      className="mt-3 w-full rounded-2xl border border-peach/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.72)_0%,rgba(255,243,236,0.95)_100%)] px-4 py-3 font-semibold text-ink outline-none transition focus:border-coral focus:ring-4 focus:ring-peach/12"
                    >
                      {["HDFC ERGO", "ICICI Lombard", "Bajaj Allianz", "Reliance General", "New India"].map(
                        (option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        )
                      )}
                    </select>
                  </div>

                  <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                    <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                      Previous year NCB
                    </label>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {["0%", "20%", "25%", "35%", "45%", "50%"].map((value) => (
                        <button
                          key={value}
                          type="button"
                          onClick={() => updateField("ncb", value)}
                          className={choiceButtonClass(formData.ncb === value)}
                        >
                          {value}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </section>

              <section className="grid gap-5 lg:grid-cols-2">
                <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                  <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                    Did you make claim in your policy?
                  </label>
                  <div className="mt-3 flex flex-wrap gap-3">
                    {["No", "Yes"].map((option) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => updateField("hadClaim", option)}
                        className={choiceButtonClass(formData.hadClaim === option)}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="rounded-[24px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.62)_0%,rgba(255,248,242,0.82)_100%)] p-4 shadow-[0_14px_30px_rgba(43,74,107,0.07)]">
                  <label className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
                    Owner Type
                  </label>
                  <div className="mt-3 flex flex-wrap gap-3">
                    {["Corporate", "Individual"].map((option) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => updateField("ownerType", option)}
                        className={choiceButtonClass(formData.ownerType === option)}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              </section>

              <div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
                <a
                  href="/buy-now"
                  className="rounded-[18px] border border-white/70 bg-[rgba(255,255,255,0.66)] px-8 py-4 text-center font-semibold text-slate-600 shadow-[0_10px_22px_rgba(43,74,107,0.05)] transition hover:-translate-y-0.5"
                >
                  BACK
                </a>
                <button
                  type="button"
                  onClick={handleViewQuotes}
                  className="rounded-[18px] bg-gradient-to-r from-peach to-coral px-8 py-4 font-semibold text-white shadow-[0_16px_30px_rgba(225,95,56,0.22)] transition hover:-translate-y-0.5"
                >
                  VIEW QUOTES -&gt;
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

window.AppPages = window.AppPages || {};
window.AppPages.VehicleQuotePage = VehicleQuotePage;
